module.exports = __webpack_public_path__ + "r-v3/img/ico_check_blue.e932cf61.svg";